import HttpService from '@/common/services/HttpService'

export const getLogoInstance = async (): Promise<string> => {
  return await HttpService.getData<string>('/webAppLogoUrl')
}
